import PublicContentBase from '../../ContentBase'
import './Styles.scss'

const PublicContentLMOTCDemo = (): JSX.Element => {
    return <PublicContentBase />
}

export default PublicContentLMOTCDemo
